import React, { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "../../constants";
import { useExperimentalMode } from "../../hooks";

interface ExperimentalRouteProps {
  children: ReactNode;
}

const ExperimentalRoute: FC<ExperimentalRouteProps> = ({ children }) => {
  const { experimentalModeEnabled, hasFeatureAccess } = useExperimentalMode();
  
  // Check both feature flag access and toggle state
  if (!hasFeatureAccess || !experimentalModeEnabled) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
};

export default ExperimentalRoute;